/* Mellow — interactions de la page d'accueil (sections mellow-*). Sans dépendance. */
(() => {
  if (window.MellowHome) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touch = matchMedia('(hover: none)').matches;

  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); reveal.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });

  const counter = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target, end = +el.dataset.count, t0 = performance.now();
      counter.unobserve(el);
      if (reduce || !end) return;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / 1100);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + '%';
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.6 });

  // Écrans tactiles : les effets « au survol » se jouent à l'arrivée dans l'écran
  const live = new IntersectionObserver((entries) => {
    entries.forEach((e) => e.target.classList.toggle('live', e.isIntersecting));
  }, { threshold: 0.55 });

  function initHero(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('.hv__track');
    const slides = [...root.querySelectorAll('.hv__slide')];
    const dotsBox = root.querySelector('.hv__dots');
    const DUR = (+root.dataset.duration || 5) * 1000;
    root.style.setProperty('--hv-dur', DUR + 'ms');
    let i = 0, timer = null;
    if (slides.length < 2) { slides[0] && slides[0].classList.add('on'); return; }
    const dots = slides.map((_, n) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Affiche ' + (n + 1));
      b.addEventListener('click', (e) => { e.preventDefault(); go(n, true); });
      dotsBox.appendChild(b);
      return b;
    });
    function go(n, user) {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      slides.forEach((s, k) => { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k !== i); s.tabIndex = k === i ? 0 : -1; });
      dots.forEach((d, k) => { d.setAttribute('aria-selected', k === i); d.style.animation = 'none'; void d.offsetWidth; d.style.animation = ''; });
      if (user) restart();
    }
    function restart() {
      clearInterval(timer);
      if (!reduce) timer = setInterval(() => { if (!root.classList.contains('paused')) go(i + 1); }, DUR);
    }
    root.addEventListener('mouseenter', () => root.classList.add('paused'));
    root.addEventListener('mouseleave', () => root.classList.remove('paused'));
    root.addEventListener('focusin', () => root.classList.add('paused'));
    root.addEventListener('focusout', () => root.classList.remove('paused'));
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true);
      x0 = null;
    });
    go(0);
    restart();
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('.mw .rv, .mw [data-rv]').forEach((el) => reveal.observe(el));
    root.querySelectorAll('.mw [data-count]').forEach((el) => counter.observe(el));
    root.querySelectorAll('.mw [data-hv]').forEach(initHero);
    if (touch) root.querySelectorAll('.mw .promo, .mw .sc, .mw .pr, .mw .flvx__card').forEach((el) => live.observe(el));
    root.querySelectorAll('.mw video[data-lazy-video], .mw video.mw-lazy-video').forEach((v) => {
      new IntersectionObserver(([e]) => { if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else { v.pause(); } }, { threshold: 0.3 }).observe(v);
    });
  }

  window.MellowHome = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  // Éditeur de thème : réinitialise la section rechargée
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
